import React from "react";
import Card from "../../../components/Card";
import TitlePage from "../../../components/TitlePage";
import MapAddressField from "../../../components/MapAddressField";
import Button from "../../../components/Button";

export default function BusinessAddressComponents({
  businessAddress,
  onLocationSelect,
  handleSubmit,
  isLoading,
  isSaving,
}) {
  return (
    <Card
      header={
        <div className="d-flex justify-content-between align-items-center w-100">
          <TitlePage text={"Alamat Klinik"} />
          <Button
            label={isSaving ? "Menyimpan..." : "Simpan"}
            onClick={handleSubmit}
            disabled={isSaving || isLoading}
            loading={isSaving}
          />
        </div>
      }
    >
      {isLoading ? (
        <div className="d-flex justify-content-center align-items-center p-5">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <span className="ms-3">Memuat alamat bisnis...</span>
        </div>
      ) : (
        <>
          <MapAddressField
            onLocationSelect={onLocationSelect}
            initialLocation={
              businessAddress
                ? {
                    lat: businessAddress.lat,
                    lng: businessAddress.lng,
                  }
                : null
            }
            initialAddress={businessAddress?.address || ""}
            height="400px"
          />
        </>
      )}
    </Card>
  );
}
